import Vue from 'vue';
import router from '@/demo1/router/';
import bowser from 'bowser';
import * as PIXI from 'pixi.js';
import {
  TweenMax, TimelineLite, TweenLite, Power3, Linear,
} from 'gsap';

let ticking = false;

const windowHeight = window.innerHeight;
const rate = bowser.mobile ? 1 : 0.95;
const bottomHeight = windowHeight * rate;

let beforeScrollTop;

function aboutScrollHandle() {
  // const fixed = document.querySelector('.section__fixed-container');
  // const fixedBCR = fixed.getBoundingClientRect();
  // const compare = document.querySelector('.summary__img');
  // const compareBCR = compare.getBoundingClientRect();
  // if (compareBCR.top + compareBCR.height <= fixedBCR.top + fixedBCR.height) {
  //   fixed.classList.add('_fixed-bottom');
  // }
  // if ((compareBCR.top + compareBCR.height - windowHeight < 0)
  //   && (Math.abs(compareBCR.top + compareBCR.height - windowHeight) <= fixed.dataset.offset)) {
  //   fixed.classList.remove('_fixed-bottom');
  // }
}

function handleScroll() {
  const scolls = [...document.querySelectorAll('.scrollObj')].filter((item) => {
    const isAnimated = item.classList.contains('animated');
    const { top, height } = item.getBoundingClientRect();
    const isInView = top <= bottomHeight && top > 0;
    const isImmediate = Number(item.dataset.immediate) === 1;
    if (isAnimated && !isInView && top - height > 0) {
      // item.classList.remove("animated");
    }
    return (!isAnimated && isInView) || isImmediate;
  });

  function handleShow(item, k) {
    const { effect } = item.dataset;
    switch (effect) {
      case 'delay':
        if (item.getBoundingClientRect().top <= window.innerHeight * 0.5) {
          item.classList.add('animated');
        }
        break;
      default:
        setTimeout(() => {
          item.classList.add('animated');
        }, k * 100);
        break;
    }
  }

  scolls.forEach((item, key) => {
    handleShow(item, key);
  });

  if (router.currentRoute.name === 'about') {
    aboutScrollHandle();
  }
  const screenScrollTop = document.body.getBoundingClientRect().top;
  if (router.currentRoute.name === 'about' && bowser.mobile && (Math.abs(screenScrollTop) >= window.innerHeight * 0.1)) {
    const dwp = document.querySelector('.summary__downward-sign-container');
    if (!dwp.classList.contains('hidden')) {
      dwp.classList.add('hidden');
    }
  }

  const header = document.querySelector('.page-header-container');
  if (bowser.mobile && header && !(router.currentRoute.matched.some((item) => item.name === 'projects'))) {
    const delta = beforeScrollTop - screenScrollTop;
    beforeScrollTop = screenScrollTop;
    if (Math.abs(screenScrollTop) >= 100) {
      if (delta < 0) {
        // 往上
        if (!header.classList.contains('fixed-donw-show')) {
          header.classList.add('fixed-donw-show');
          TweenLite.fromTo(header, 0.8, {
            y: -100,
          },
          {
            y: 0,
            ease: Power3.easeOut,
          });
        }
      } else {
        header.classList.remove('fixed-donw-show');
      }
    } else {
      header.classList.remove('fixed-donw-show');
    }
  }

  ticking = false;
}

function onScroll() {
  if (!ticking) {
    requestAnimationFrame(handleScroll);
    ticking = true;
  }
}

function pageInit() {
  onScroll();
  if (router.currentRoute.name === 'about') {
    const fixed = document.querySelector('.section__fixed-container');
    if (fixed) {
      const fixedBCR = fixed.getBoundingClientRect();
      fixed.dataset.offset = windowHeight - (fixedBCR.top + fixedBCR.height);
    }
  }
  beforeScrollTop = document.body.getBoundingClientRect().top;
  window.addEventListener('scroll', onScroll);
}

// 自动撑高度
function heightFullScreen(wrapper) {
  const tempWrap = wrapper;
  const height = window.innerHeight;
  Vue.nextTick(() => {
    const currentHeight = document.body.getBoundingClientRect().height;
    const wrapperHeight = currentHeight < height ? height - currentHeight : 500;
    tempWrap.style.cssText = `height: ${tempWrap.getBoundingClientRect()
      .height + wrapperHeight}px`;
  });
}

function preload(obj, type) {
  const arr = Array.from(obj);
  return Promise.all(
    arr
      .filter((item) => {
        const data = item.dataset;
        return type === 'src' ? true : data.src !== '';
      })
      .map((item) => {
        let src;
        if (type === 'src') {
          src = item;
        } else {
          // const { tagName } = item;
          const data = item.dataset;
          src = data.src;
        }
        return new Promise((res, rej) => {
          const img = new Image();
          img.onload = () => {
            setTimeout(() => {
              res(img.src);
            }, 1000);
          };
          img.onerror = () => {
            rej();
          };
          img.src = src;
        });
      }),
  );
}

export const sliderShow = {
  init(afterMove) {
    this.view = document.querySelector('.index-hero-container');
    this.$collection = this.view.querySelector('.jsCollection');
    this.$items = this.view.querySelectorAll('.jsItem');
    // this.$canvas = document.querySelector('.jsCanvas');
    // this.$progress = this.view.querySelector('.jsProgress');
    this.$previous = this.view.querySelector('.prev');
    this.$next = this.view.querySelector('.next');
    this.$pagination = this.view.querySelectorAll('.pagination__item');
    if (this.$pagination.length > 0) {
      this.$pagination[0].classList.add('swiper-pagination-bullet-active');
    }
    this.OLD_INDEX = 0;
    this.CURRENT_INDEX = 0;
    this.TOTAL = this.$items.length - 1;
    this.DIRECTION = 0;
    this.IS_MOVING = false;
    this.indicator = 0;
    this.durationAutoplay = 5;
    this.timerAutoplay = 0;
    this.circleTween = 0;
    this.progressCircle = {
      progress: 0,
    };

    this.renderer = new PIXI.autoDetectRenderer({
      width: 100,
      height: 100,
      transparent: true,
      antialias: true,
    });
    this.stage = new PIXI.Container();
    this.circleGraphic = new PIXI.Graphics();
    this.circleSettings = {
      color: 16777215,
      radius: 10,
      degree: 270,
      initAngle: this.degreeToRadian(270),
      firstDraw: this.degreeToRadian(270),
    };
    this.circleTween = false;
    this.progressCircle = {
      progress: 0,
    };

    if (afterMove) {
      this.afterMove = afterMove;
    }

    this.setup();
    this.launch();
  },
  launch() {
    const t = this;
    if (t.TOTAL > 0) {
      const i = t.$items[t.CURRENT_INDEX];
      const u = i.querySelector('.bg_img');
      TweenLite.fromTo(u, this.durationAutoplay + 3, {
        scale: 1.04,
      },
      {
        scale: 1,
        ease: Power3.easeOut,
        delay: 0.2,
      });
      this.animateProcess(this.durationAutoplay + 1, 0.5, 'show');
      setTimeout(() => {
        t.autoplay();
      }, 1100);
      t.animateCircle();
    }
  },
  animateProcess(duration, delay, effect) {
    const t = this;
    const process = document.querySelector('.index-hero-pagination .mask');
    if (process) {
      if (effect === 'show') {
        TweenLite.fromTo(process, duration, {
          clipPath: 'inset(0 50px 0 0)',
        }, {
          clipPath: 'inset(0 0px 0 0)',
          delay,
        });
      } else if (effect === 'hidden') {
        TweenLite.fromTo(process, duration, {
          clipPath: 'inset(0 0px 0 0)',
        }, {
          clipPath: 'inset(0 0px 0 50px)',
          delay,
          ease: Power3.easeInOut,
          onComplete() {
            TweenLite.fromTo(process, t.durationAutoplay + 2, {
              clipPath: 'inset(0 50px 0 0)',
            }, {
              clipPath: 'inset(0 0px 0 0)',
              delay: 0,
            });
          },
        });
      }
    }
  },
  animateCircle() {
    const t = this;
    this.progressCircle = {
      progress: 0,
    };
    this.circleTween = TweenLite.to(this.progressCircle, this.durationAutoplay + 1, {
      immediateRender: false,
      progress: 1,
      ease: Linear.easeNone,
      onUpdate() {
        let e = 360 * t.progressCircle.progress;
        e += t.circleSettings.degree;
        const i = t.degreeToRadian(e);
        t.circleGraphic.clear();
        t.circleGraphic.beginFill(t.circleSettings.color, 1);
        t.circleGraphic.lineStyle();
        t.circleGraphic.arc(
          t.circleSettings.radius,
          t.circleSettings.radius,
          t.circleSettings.radius,
          t.circleSettings.initAngle,
          i,
        );
        t.circleGraphic.lineTo(t.circleSettings.radius, t.circleSettings.radius);
        t.circleGraphic.endFill();
        t.renderer.render(t.stage);
      },
    });
  },
  degreeToRadian(t) {
    return (t * Math.PI) / 180;
  },
  goToNext() {
    if (!this.IS_MOVING) {
      this.DIRECTION = 1;
      this.CURRENT_INDEX += 1;
      if (this.CURRENT_INDEX > this.TOTAL) {
        this.CURRENT_INDEX = 0;
      }
      this.move();
    }
  },
  goToPrevious() {
    if (!this.IS_MOVING) {
      this.DIRECTION = -1;
      this.CURRENT_INDEX -= 1;
      if (this.CURRENT_INDEX < 0) {
        this.CURRENT_INDEX = this.TOTAL;
      }
      this.move();
    }
  },
  move() {
    const t = this;
    const e = this.$items[this.OLD_INDEX];
    const i = this.$items[this.CURRENT_INDEX];
    const u = i.querySelector('.bg_img');
    const h = i.querySelectorAll('.jsTextFx');

    t.animateProcess(0.7, 0, 'hidden');

    const r = new TimelineLite({
      onComplete() {
        // TweenLite.to(u, t.durationAutoplay, {
        //   scale: 1,
        // });
        t.twIsComplete();
      },
    });
    let o = '';
    let s = '';
    const n = this.view.getBoundingClientRect();
    if (this.DIRECTION > 0) {
      o = `rect(0px,0px,${n.height}px,0px)`;
      s = `rect(0px,${n.width}px,${n.height}px,0px)`;
    } else {
      o = `rect(0px,${n.width}px,${n.height}px,${n.width}px)`;
      s = `rect(0px,${n.width}px,${n.height}px,0px)`;
    }
    if (this.OLD_INDEX !== this.CURRENT_INDEX) {
      if (t.afterMove && typeof t.afterMove === 'function') {
        t.afterMove(t.CURRENT_INDEX);
      }
      this.IS_MOVING = true;
      this.updating();
      // TweenLite.to(this.$canvas, 0.3,
      //   {
      //     scale: 0,
      //     ease: Power3.easeInOut,
      //     onComplete() {
      //       t.circleTween.kill();
      //       t.progressCircle.progress = 0;
      //     },
      //   });
      // TweenLite.to();canvas
      r.kill();
      r.call(() => {
        TweenLite.set(i, {
          clip: o,
        });
        e.style.zIndex = 2;
        i.style.zIndex = 3;
        i.classList.remove('disabled');
        i.classList.add('enabled');
      });

      TweenLite.fromTo(u, this.durationAutoplay + 3, {
        scale: 1.04,
      },
      {
        scale: 1,
        ease: Power3.easeOut,
        delay: 0.2,
      });

      r.add([
        // canvas
        // TweenLite.to(this.$canvas, 0.35, {
        //   scale: 1,
        //   ease: Power3.easeOut,
        //   delay: 0.35,
        //   onStart() {
        //     t.animateCircle();
        //   },
        // }),
        TweenLite.to(i, 0.7, {
          clip: s,
          ease: Power3.easeInOut,
        }),
        TweenMax.staggerFromTo(h, 1,
          {
            opacity: 0,
            y: 100,
          },
          {
            opacity: 1,
            y: 0,
            delay: 0.5,
            ease: Power3.easeOut,
          }, 0.05),
        // 进度条
        // TweenLite.fromTo(this.$progress, 0.7, {
        //   x: '-100%',
        // },
        // {
        //   x: '100%',
        //   ease: Power3.easeInOut,
        // }),
      ]);

      r.add(() => {
        TweenLite.set(h, {
          clearProps: 'all',
        });
        TweenLite.set(i, {
          clearProps: 'clip',
        });
        TweenLite.set(e, {
          clearProps: 'clip',
        });
      });

      r.restart();
    }

    if (this.$pagination.length > 0) {
      this.$pagination.forEach((item, index) => {
        if (index === this.CURRENT_INDEX) {
          item.classList.add('swiper-pagination-bullet-active');
        } else {
          item.classList.remove('swiper-pagination-bullet-active');
        }
      });
    }
  },
  twIsComplete() {
    this.IS_MOVING = false;
    this.OLD_INDEX = this.CURRENT_INDEX;
    this.finalize();
    this.autoplay();
  },
  autoplay() {
    const t = this;
    this.timerAutoplay = window.setTimeout(() => {
      t.goToNext();
    }, 1e3 * this.durationAutoplay);
  },
  setup() {
    const that = this;
    // that.$canvas.appendChild(this.renderer.view);
    // if (that.TOTAL > 0) {
    //   that.drawCircle();
    // }
    that.$previous.addEventListener('click', () => {
      clearTimeout(that.timerAutoplay);
      that.goToPrevious();
    });
    that.$next.addEventListener('click', () => {
      clearTimeout(that.timerAutoplay);
      that.goToNext();
    });
    that.updating();
    that.finalize();
  },
  drawCircle() {
    this.circleGraphic.beginFill(this.circleSettings.color, 1);
    this.circleGraphic.arc(
      this.circleSettings.radius,
      this.circleSettings.radius,
      this.circleSettings.radius,
      this.circleSettings.initAngle,
      this.circleSettings.firstDraw,
    );
    this.circleGraphic.lineTo(this.circleSettings.radius, this.circleSettings.radius);
    this.circleGraphic.endFill();
    this.stage.addChild(this.circleGraphic);
    this.renderer.render(this.stage);
  },
  updating() {
    if (this.CURRENT_INDEX > 0) {
      this.view.classList.add('is--scrolling');
    } else {
      this.view.classList.remove('is--scrolling');
    }
  },
  finalize() {
    if (this.$items.length > 0) {
      const t = this.$items[this.CURRENT_INDEX];
      for (let e = 0; e < this.$items.length; e += 1) {
        const i = this.$items[e];
        if (i.classList.contains('disabled')) {
          i.classList.remove('disabled');
        }
        if (i.classList.contains('enabled')) {
          i.classList.remove('enabled');
        }
        i.style.zIndex = 0;
        if (e !== this.CURRENT_INDEX) {
          i.classList.add('disabled');
        }
      }
      t.classList.add('enabled');
      t.style.zIndex = 1;
    }
  },
};

function IEVersion() {
  const { userAgent } = navigator; // 取得浏览器的userAgent字符串
  // 判断是否IE<11浏览器
  const isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1;
  const isEdge = userAgent.indexOf('Edge') > -1 && !isIE; // 判断是否IE的Edge浏览器
  const isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1;
  if (isIE) {
    const reIE = new RegExp('MSIE (\\d+\\.\\d+);');
    reIE.test(userAgent);
    const fIEVersion = parseFloat(RegExp.$1);
    if (fIEVersion === 7) {
      return 7;
    } if (fIEVersion === 8) {
      return 8;
    } if (fIEVersion === 9) {
      return 9;
    } if (fIEVersion === 10) {
      return 10;
    }
    return 6;// IE版本<=7
  } if (isEdge) {
    // return 'edge';// edge
    return -1;
  } if (isIE11) {
    return 11; // IE11
  }
  return -1;// 不是ie浏览器
}

function isWX() {
  const ua = window.navigator.userAgent.toLowerCase();
  return ua.match(/micromessenger/i) || ua.match(/wechatdevtools/i);
}

export default {
  install: () => {
    Vue.prototype.heightFullScreen = (wrapper) => heightFullScreen(wrapper);
    Vue.prototype.pageInit = () => pageInit();
    Vue.prototype.preload = (obj, type) => preload(obj, type);
    Vue.prototype.IEVersion = () => IEVersion();
    Vue.prototype.isWX = () => isWX();
  },
};
